import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_WITHDRAWALS_HISTORY = Symbol('withdrawals-history');

export const ADMIN_WITHDRAWALS_HISTORY_ROUTE_NAME = Symbol('admin.withdrawals-history');
export const ADMIN_WITHDRAWALS_HISTORY_LIST_ROUTE_NAME = Symbol('admin.withdrawals-history.list');

export const WITHDRAWALS_HISTORY_LIST_API_URL = 'admin/affiliate_cashouts/approved_and_declined_history/list';
export const WITHDRAWALS_HISTORY_DOWNLOAD_REPORT_URL = 'admin/affiliate_cashouts/approved_and_declined_history/download_report';
export const WITHDRAWALS_HISTORY_LIST_QUERY_KEY = 'withdrawals-history.list';
export const WITHDRAWALS_HISTORY_DOWNLOAD_REPORT_MUTATION_KEY = 'withdrawals-history.download-report';

export const WITHDRAWALS_HISTORY_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.AFFILIATECASHOUTS_WITHDRAWALS_HISTORY_SHOW),
  DOWNLOAD_LIST: new Permission(PermissionsList.admin.AFFILIATECASHOUTS_WITHDRAWALS_HISTORY_DOWNLOAD),
};
